module.exports = __webpack_public_path__ + "static/mobile-hero-7e7bf2da466208d2fbb36fffb08bc659.png";